/**
 * Copia texto al portapapeles de forma robusta
 * Compatible con navegadores móviles y de escritorio
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  // Método 1: Intentar con la API moderna de Clipboard
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.warn('Clipboard API falló, intentando método alternativo:', err);
    }
  }

  // Método 2: Fallback usando execCommand (compatible con móviles antiguos)
  try {
    // Crear un elemento de texto temporal
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // Hacer el textarea invisible pero accesible
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    textArea.style.opacity = '0';
    textArea.setAttribute('readonly', '');
    
    document.body.appendChild(textArea);
    
    // Seleccionar el texto
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      // iOS requiere un manejo especial
      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }
    
    // Copiar el texto seleccionado
    const successful = document.execCommand('copy');
    
    // Limpiar
    document.body.removeChild(textArea);
    
    return successful;
  } catch (err) {
    console.error('Error al copiar al portapapeles:', err);
    return false;
  }
};
